import {
  Cursive,
  CurveBanner,
  Header,
  Title,
  Wrapper,
  GradientWrap,
  HeroText,
  BackgroundWrap
} from '~/ui'
import { CursiveBasic } from '~/ui/cursive-basic'

export const HeadContent = () => (
  <BackgroundWrap className="h-full w-full md:bg-slide-2">
    <GradientWrap className="bg-colorFourteen md:bg-transparent md:from-colorFourteen md:via-colorFourteen md:to-transparent">
      <CurveBanner>
        <div className="container mx-auto p-0 px-6">
          <h1 className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
            Our Story
          </h1>
        </div>
      </CurveBanner>
      <div className="relative">
        <div className="container mx-auto px-6 pt-20 pb-0">
          <div className="">
            <div className="absolute top-0 left-0 block h-full w-full bg-slide-2 bg-cover bg-top md:hidden" />
            <div className="absolute top-0 left-0 block h-full w-full bg-gradient-to-t from-colorFourteen to-transparent md:hidden" />
            <div className="relative">
              <div className="h-[200px]" />
              <Title className="text-colorFifteen">Tucker Tub</Title>
              <CursiveBasic>All natural dog food, made farm fresh</CursiveBasic>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 pt-0">
        <div className="pb-20">
          <div className="pt-8 text-colorFifteen">
            <HeroText>
              At Tucker Tub, dogs are family. We want what's best for them. That's why your pup's
              gut health is so important to us.
            </HeroText>
            <br />
            <HeroText>
              Conventional pet food is full of additives, fillers, and other nutrient-poor
              ingredients. Some are even harmful to your furry friend's digestive system. Tucker Tub
              was created to change the way we feed our dogs.
            </HeroText>
            <br />
            <HeroText>
              We've been crafting dog food using fresh ingredients from local farms in country
              Victoria since our inception over 25 years ago. As one of the pioneers of natural dog
              food in Australia, we understand what's best for different breeds - including those
              with food sensitivities and allergies.
            </HeroText>
            <br />
            <HeroText>
              With Tucker Tub, you can feel confident you're giving your dog nutritious, natural
              food that's best for them. That's puppy love.
            </HeroText>
          </div>
        </div>
      </div>
    </GradientWrap>
  </BackgroundWrap>
)
